import ModalChangEmail from "../ModalChangEmail/ModalChangEmail"
import OnboardingStepItem from "../OnboardingStepItem"
import StepSectionHeader from "../StepSectionHeader"
import useOnboardingStepsBlock from "./hooks/useOnboardingStepsBlock"

import "../../styles.less"

const OnboardingStepsBlock = () => {
  const {
    email,
    openModal,
    initStep,
    resendDeadline,
    totalSteps,
    preparedSteps,
    handleContinue,
    handleOpenModal,
    handleCloseModal,
    handleResend,
    verifyButtonState,
    completedPrimarySteps,
    completedSecondarySteps
  } = useOnboardingStepsBlock()

  return (
    <>
      <StepSectionHeader
        title="Verification"
        completed={completedPrimarySteps}
        total={totalSteps}
      />
      {preparedSteps.map((s) => (
        <>
          <OnboardingStepItem
            id={s.id}
            step={s.step}
            title={s.title}
            description={s.description}
            handleContinue={handleContinue}
            handleOpenModal={handleOpenModal}
            verifyButtonState={verifyButtonState}
            isVerify={s.isEdit}
            isEdit={s.isEdit}
            isDivider={s.isDivider}
            isComlete={s.isCompleted}
            isContinue={s.isContinue}
          />
          {s.id === 1 && (
            <StepSectionHeader
              title="Getting started"
              completed={completedSecondarySteps}
              total={6}
            />
          )}
        </>
      ))}
      <ModalChangEmail
        open={openModal}
        initStep={initStep}
        onClose={handleCloseModal}
        resendDeadline={resendDeadline}
        onResend={handleResend}
        currentEmail={email}
      />
    </>
  )
}

export default OnboardingStepsBlock
